import { ApiUrlUtil } from "../../utils/apiUrlUtil";
import axios from "axios";
import { HeadersUtil } from "../../utils/headersUtil";
import { ActvScop } from "app/model/cp/actvScop";
import Api from "app/services/common/Api";
import { ActvMgnl } from "app/model/cp/actvMgnl";
import { ActvOrg } from "../../model/cp/actvOrg";
import { ExistCpDataModel } from "../../model/cp/ExistData";

export class ActvScopService extends Api {
  private static DELETE_LIST_URL: string = process.env["REACT_APP_URL_CP"] + "/actv/actvScopListDelete";
  private static GET_REPORT_URL: string = process.env["REACT_APP_URL_CP"] + "/report/actv";
  private static GET_ROADMAP_URL: string = process.env["REACT_APP_URL_CP"] + "/report/getRoadmap";
  private static GET_ROADMAP_ADMIN_URL: string = process.env["REACT_APP_URL_CP"] + "/report/getRoadmapAdmin";
  private static GET_EMISSION_STATUS_URL: string = process.env["REACT_APP_URL_CP"] + "/report/emissionStatus";
  private static GET_ADMIN_EMISSION_STATUS_URL: string = process.env["REACT_APP_URL_CP"] + "/report/emissionAdminStatus";
  private static GET_EXIST_CP_DATA: string = process.env["REACT_APP_URL_CP"] + "/actv/mgnl/exist";
  private static GET_EXIST_CP_INVENTORY_DATA: string = process.env["REACT_APP_URL_CP"] + "/actv/mgnl/exist/inventory";
  private static GET_CARBON_EMISSION_USER_URL: string = process.env["REACT_APP_URL_CP"] + "/report/carbonEmissionUser";
  private static GET_CARBON_EMISSION_ADMIN_URL: string = process.env["REACT_APP_URL_CP"] + "/report/carbonEmissionAdmin";
  private static GET_COM_ANA_CAR_EMISS_URL: string = process.env["REACT_APP_URL_CP"] + "/report/comAnaCarEmiss";
  private static _boardService: ActvScopService;
  static readonly deleteRow: any;

  // instance 생성
  public static getInstance(): ActvScopService {
    if (!ActvScopService._boardService) {
      ActvScopService._boardService = new ActvScopService();
    }
    return ActvScopService._boardService;
  }

  // 사용자 년도별 매출액 조회
  public getSalesAmt(fuflYy: string) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP + "/actv/select?fuflYy=" + fuflYy
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeaders(),
    });
  }

  // 사용자 년도별 매출액 저장
  public async saveSalesAmt(data: any) {
    return await super.post<ActvScop>(
      process.env.REACT_APP_URL_CP + "/actv/save",
      data
    );
  }

  // 사용자 년도별 매출액 저장
  public async saveEmsnBoardByFuflYy(data: any) {
    return await super.post<ActvScop>(
        process.env.REACT_APP_URL_CP + "/actv/save/boundary",
        data
    );
  }

  // 사용자 scope 체크 값 조회
  public async getCheckScope() {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP + "/actv/mgnl/select"
    );
    return await super.get<ActvMgnl>(url);
  }

  public async saveOrgSetting(orgData: ActvOrg[], scopData: ActvMgnl) {
    return await super.post<any>(process.env.REACT_APP_URL_CP + "/actvorg", {
      orgData: orgData,
      scopData: scopData,
    });
  }

  public async deleteActvScop(actvScop: ActvScop[]) {
    return await super.post<ActvScop[]>(ActvScopService.DELETE_LIST_URL, {
      deleteRows: actvScop,
    });
  }

  public async deleteActvScopList(actvScop: any[]) {
    return await super.post<any[]>(
      process.env["REACT_APP_URL_CP"] + "/actv/scopMmQntDel",
      { deleteRows: actvScop }
    );
  }

  public async getActvOrg() {
    return await super.get<ActvOrg[]>(
      process.env.REACT_APP_URL_CP + "/actvorg"
    );
  }

  public async getActvOrgData(year: string) {
    return await super.get<[]>(
      process.env.REACT_APP_URL_CP + `/actvorg/scopeData/${year}`
    );
  }

  public async getScop1(fuflYy: any, scopId: any, orgId: any) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP + "/actvScop/scop1",
      { fuflYy: fuflYy, scopId: scopId, orgId: orgId ?? "" }
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeaders(),
    });
  }

  // Hàm gọi API POST /scop1
  public async insertScop1(data: any) {
    return await super.post<ActvScop>(
      process.env.REACT_APP_URL_CP + "/actvScop/scop1",
      data
    );
  }

  // Hàm gọi API PUT /scop1
  public async updateScop1(data: any) {
    return await super.put<ActvScop>(
      process.env.REACT_APP_URL_CP + "/actvScop/scop1",
      data
    );
  }

  public async insertScop1Boundary(data: any) {
    return await super.post<ActvScop>(
        process.env.REACT_APP_URL_CP + "/actvScop/boundary/scop1",
        data
    );
  }

  public async updateScop1Boundary(data: any) {
    return await super.put<ActvScop>(
        process.env.REACT_APP_URL_CP + "/actvScop/boundary/scop1",
        data
    );
  }

  public async getScop2(fuflYy: any, scopId: any, orgId: any) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP + "/actvScop/scop2",
      { fuflYy: fuflYy, scopId: scopId, orgId: orgId ?? "" }
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeaders(),
    });
  }

  public async insertScop2(data: any) {
    return await super.post<ActvScop>(
      process.env.REACT_APP_URL_CP + "/actvScop/scop2",
      data
    );
  }

  public async updateScop2(data: any) {
    return await super.put<ActvScop>(
      process.env.REACT_APP_URL_CP + "/actvScop/scop2",
      data
    );
  }

  public async insertScop2Boundary(data: any) {
    return await super.post<ActvScop>(
        process.env.REACT_APP_URL_CP + "/actvScop/boundary/scop2",
        data
    );
  }

  public async updateScop2Boundary(data: any) {
    return await super.put<ActvScop>(
        process.env.REACT_APP_URL_CP + "/actvScop/boundary/scop2",
        data
    );
  }

  public async getScop3(fuflYy: any, scopId: any, orgId: any) {
    const url = ApiUrlUtil.buildQueryString(
      process.env.REACT_APP_URL_CP + "/actvScop/scop3",
      { fuflYy: fuflYy, scopId: scopId, orgId: orgId ?? "" }
    );
    return axios.get(url, {
      headers: HeadersUtil.getHeaders(),
    });
  }

  public async insertScop3(data: any) {
    return await super.post<ActvScop>(
      process.env.REACT_APP_URL_CP + "/actvScop/scop3",
      data
    );
  }

  public async updateScop3(data: any) {
    return await super.put<ActvScop>(
      process.env.REACT_APP_URL_CP + "/actvScop/scop3",
      data
    );
  }

  public async insertScop3Boundary(data: any) {
    return await super.post<ActvScop>(
        process.env.REACT_APP_URL_CP + "/actvScop/boundary/scop3",
        data
    );
  }

  public async updateScop3Boundary(data: any) {
    return await super.put<ActvScop>(
        process.env.REACT_APP_URL_CP + "/actvScop/boundary/scop3",
        data
    );
  }

  public async getFcltNm() {
    return await super.get<ActvScop>(
      process.env.REACT_APP_URL_CP + "/actv/data/fcltNm"
    );
  }

  public async saveOrgId(data: any) {
    return await super.post<ActvScop>(
      process.env.REACT_APP_URL_CP + "/actv/data",
      data
    );
  }

  public async getReportData(data: any) {
    return await super.get<any>(ActvScopService.GET_REPORT_URL, data);
  }

  public async getScopeDataByBzknd(btnType: string) {
    return await super.get(
      process.env.REACT_APP_URL_CP + "/EmissionsStatus/bzknd?search=" + btnType
    );
  }

  public getRoadmap() {
    const url = ApiUrlUtil.buildQueryString(ActvScopService.GET_ROADMAP_URL);
    return super.get(url);
  }

  public getRoadmapAdmin(param: any) {
    const url = ApiUrlUtil.buildQueryString(
      ActvScopService.GET_ROADMAP_ADMIN_URL
    );
    return super.get(url, param);
  }

  public getEmissiopnStatus(param: any) {
    const url = ApiUrlUtil.buildQueryString(
      ActvScopService.GET_EMISSION_STATUS_URL
    );
    return super.get(url, param);
  }

  public getEmissiopAdminStatus(param: any) {
    const url = ApiUrlUtil.buildQueryString(
      ActvScopService.GET_ADMIN_EMISSION_STATUS_URL
    );
    return super.get(url, param);
  }

  public async existCpData(data: string[]) {
    const url = ApiUrlUtil.buildQueryString(ActvScopService.GET_EXIST_CP_DATA);
    return await super.post<ExistCpDataModel>(url, data);
  }

  public async existCpInventoryAndReference(year: string) {
    const url = ApiUrlUtil.buildQueryString(ActvScopService.GET_EXIST_CP_INVENTORY_DATA);
    return await super.post<ExistCpDataModel>(url, year);
  }

  public getCarbonEmissionUser(param: any) {
    const url = ApiUrlUtil.buildQueryString(
      ActvScopService.GET_CARBON_EMISSION_USER_URL
    );
    return super.get(url, param);
  }

  public getCarbonEmissionAdmin(param: any) {
    const url = ApiUrlUtil.buildQueryString(
      ActvScopService.GET_CARBON_EMISSION_ADMIN_URL
    );
    return super.get(url, param);
  }

  public getComAnaCarEmiss(param: any) {
    const url = ApiUrlUtil.buildQueryString(
      ActvScopService.GET_COM_ANA_CAR_EMISS_URL
    );
    return super.get<any>(url, param);
  }
}
